<template>
    <div>
        <div v-if="filteredOffers.length && !isDisableTableView" class="d-flex justify-end">
            <v-btn :disabled="tableView" variant="flat" size="x-small" @click="toggleTableView(true)">
                <v-icon size="small">mdi-table-large</v-icon>
            </v-btn>
            <v-btn :disabled="!tableView" variant="flat" size="x-small" @click="toggleTableView(false)">
                <v-icon size="small">mdi-table-of-contents</v-icon>
            </v-btn>
        </div>
        <template v-if="!tableView && groupedOffersByPage">
            <component
                :is="component"
                v-for="(offer, index) in groupedOffersByPage"
                :key="`group-${index}`"
                :offers="offer"
                :group-type="groupOffersBy"
                :page="page"
                :data-cy="`tour-offer-${index}`"
            />
        </template>
        <template v-else-if="tableView && filteredOffers.length">
            <tour-offer-table-view :offers="filteredOffers" />
        </template>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import TourOfferCard from '@/components/tours/search/offers/TourOfferCard.vue'
    import TourOfferCardMobile from '@/components/tours/search/offers/TourOfferCardMobile.vue'
    import TourOfferTableView from '@/components/tours/search/offers/TourOfferTableView.vue'

    @Component({
        components: {
            TourOfferCard,
            TourOfferCardMobile,
            TourOfferTableView,
        },
    })
    export class TourOffers extends Vue {
        @Prop() page

        tableView = true

        @Watch('isDisableTableView', {immediate: true})
        onIsDisableTableViewChange() {
            if (this.isDisableTableView) {
                this.tableView = false
            }
        }

        created() {
            if (this.isDisableTableView) {
                this.tableView = false
            } else {
                this.tableView = this.$conf.public.search.tours.tableViewByDefault
            }
        }

        toggleTableView(val) {
            if (val) {
                toursStore.SET_GROUP_OFFERS_BY('none')
                toursStore.SET_SORT_FN_NAME('dateAsc')
                toursRuntimeStore.sort()
                this.tableView = true
            } else {
                this.tableView = false
            }
        }

        get isDisableTableView() {
            return !!this.filteredOffers.find(o => o.info?.staticPrice === true)
        }

        get filteredOffers() {
            return toursRuntimeStore.offers
        }

        get groupedOffersByDay() {
            return toursRuntimeStore.offers?.reduce((groupedOffers, offer) => {
                if (groupedOffers.length) {
                    if (
                        groupedOffers.some(el =>
                            el.some(
                                item =>
                                    item.info.packageDate === offer.info.packageDate &&
                                    item.info.name === offer.info.name
                            )
                        )
                    ) {
                        groupedOffers.forEach((group, index) => {
                            if (
                                group.some(
                                    el =>
                                        el.info.packageDate === offer.info.packageDate &&
                                        el.info.name === offer.info.name
                                )
                            )
                                groupedOffers[index].push(offer)
                        })
                    } else {
                        groupedOffers.push([offer])
                    }
                } else groupedOffers = [[offer]]

                return groupedOffers
            }, [])
        }

        get groupedOfferByName() {
            return toursRuntimeStore.offers?.reduce((groupedOffers, offer) => {
                if (groupedOffers.length) {
                    if (groupedOffers.some(el => el.some(item => item.info.name === offer.info.name))) {
                        groupedOffers.forEach((group, index) => {
                            if (group.some(el => el.info.name === offer.info.name)) groupedOffers[index].push(offer)
                        })
                    } else {
                        groupedOffers.push([offer])
                    }
                } else groupedOffers = [[offer]]

                return groupedOffers
            }, [])
        }

        get groupedOffers() {
            if (this.groupOffersBy === 'tourName') {
                return this.groupedOfferByName
            }
            return this.groupedOffersByDay
        }

        get groupedOffersByPage() {
            const index = this.$conf.public.search.resultsOnPage * (this.page - 1)
            return this.groupedOffers.slice(index, index + this.$conf.public.search.resultsOnPage)
        }

        get pages() {
            return Math.ceil(this.groupedOffers?.length / this.$conf.public.search.resultsOnPage)
        }

        get groupOffersBy() {
            return toursStore.groupOffersBy
        }

        get component() {
            return !this.$breakpoint.smAndDown
                ? resolveComponent('TourOfferCard')
                : resolveComponent('TourOfferCardMobile')
        }
    }

    export default TourOffers
</script>
